/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {CreateWrapper} from './container/CreateManager'
import {ListWraper} from './container/List'

export function ManagerPage() {
  useEffect(() => {}, [])

  return (
    <div>
      <Switch>
        <Route path='/manager/list' exact={true} component={ListWraper} />
        <Route path='/manager/create' exact={true} component={CreateWrapper} />
        <Redirect from='/manager' exact={true} to='/manager/list' />
        <Redirect to='/manager/list' />
      </Switch>
    </div>
  )
}
